import { me } from '../../const';
import { PermeatorPlatform } from '../PermeatorExt';

const p: PermeatorPlatform = {
    push(url:string) {
        me.location.href = url;
    },
    open(url:string) {
        me.open(url);
    },
    close() {
        me.close();
    }
};

export default p;
